<template>
  <div id="app" :class="{ loading }">
    <router-view name="sidebar" class="sidebar-view" />
    <router-view name="header" class="header-view" />
    <router-view class="main-view" id="main-view" :key="$route.fullPath" />
    <project-modal />
    <action-tray />
  </div>
</template>

<script>
import ProjectModal from './components/ProjectModal';
import ActionTray from './components/ActionTray';
import VTooltip from 'v-tooltip';

export default {
  name: 'App',
  data: () => ({
    stakeholder: true
  }),
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
  },
  components: {
    'project-modal': ProjectModal,
    'action-tray': ActionTray,
  },
  created() {
    VTooltip.options.defaultClass = 'my-tooltip';
  },
};
</script>

<style lang="scss">
@import './styles/_styles.scss';
//.main-view:not(.self-service-main) {
//  @import './styles/typography.scss';
//  @import './styles/tables.scss';
//}
//
//.header-view{
//  @import './styles/typography.scss';
//}
//
//.sidebar-view{
//  @import './styles/typography.scss';
//}
//
//.project-modal{
//  @import './styles/typography.scss';
//  @import './styles/buttons.scss';
//  @import './styles/colors';
//}
//
//.action-tray{
//  @import './styles/typography.scss';
//  @import './styles/buttons.scss';
//  @import './styles/colors';
//}
//
//@import './styles/colors';
//@import './styles/common';
//@import './styles/forms';
//@import './styles/dialogs';
//@import './styles/datepicker';
//@import './styles/buttons.scss';
#app {
  width: 100%;
  height: 100vh;
  background-color: $bg-color;

  font-family: 'Ubuntu', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $dark-color;

  &.loading {
    cursor: progress;
  }
}

.main-view {
  width: 100%;
  height: 100%;
  padding: 40px;
  /* overflow-x: hidden; */
  overflow-y: auto;
}

.sidebar-view ~ .main-view {
  margin-left: 320px;
  width: calc(100% - 320px);

  @media screen and (max-width: 1430px) {
    margin-left: 0px;
    width: 100%;
  }
}

.header-view ~ .main-view {
  margin-top: 80px;
  height: calc(100% - 80px);
}

.self-service-view {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.fill-height{
  height: 100%;
}

.bord {
  border: 1px solid fuchsia;
}
</style>
